<br />
<br />
<br />
<div class="card-data">
  <form [formGroup]="paymentForm">
    <h3 class="text-center">
      {{ "Payment" | translate }}
    </h3>
   <!-- Display Product -->
    <div class="row text-center" *ngIf="product">
      <div>
        <small>{{ product.description }}</small>
      </div>
      <div>
        <small>{{ product.amount / 100 }} {{ "L.E" | translate }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <label>{{ "First Name" | translate }}*</label>
        <input
          type="text"
          placeholder="{{ 'Enter your first name' | translate }}"
          formControlName="firstName"
        />
        <div
          *ngIf="
            paymentForm.get('firstName')?.invalid &&
            paymentForm.get('firstName')?.touched
          "
          class="text-danger"
        >
          <small *ngIf="paymentForm.get('firstName')?.errors?.['required']">
            {{ "First name is required" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Last Name" | translate }}*</label>
        <input
          type="text"
          formControlName="lastName"
          placeholder="{{ 'Enter your last name' | translate }}"
        />
        <div
          *ngIf="
            paymentForm.get('lastName')?.touched &&
            paymentForm.get('lastName')?.errors
          "
          class="text-danger"
        >
          <small *ngIf="paymentForm.get('lastName')?.errors?.['required']">
            {{ "Last name is required" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Phone Number" | translate }}*</label>

        <input
          type="number"
          placeholder="{{ 'Enter your phone number' | translate }}"
          formControlName="phone"
        />
        <div
          *ngIf="
            paymentForm.get('phone')?.touched &&
            paymentForm.get('phone')?.errors
          "
          class="text-danger"
        >
          0
          <small *ngIf="paymentForm.get('phone')?.errors?.['required']">
            {{ "Phone number is required" | translate }}
          </small>
          <small *ngIf="paymentForm.get('phone')?.errors?.['pattern']">
            {{ "Invalid phone number format" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Email" | translate }}*</label>

        <input
          type="email"
          placeholder="{{ 'Enter your email' | translate }}"
          formControlName="email"
        />
        <div
          *ngIf="
            paymentForm.get('email')?.touched &&
            paymentForm.get('email')?.errors
          "
          class="text-danger"
        >
          <small *ngIf="paymentForm.get('email')?.errors?.['required']">
            {{ "Email is required" | translate }}
          </small>
          <small *ngIf="paymentForm.get('email')?.errors?.['email']">
            {{ "Invalid email format" | translate }}
          </small>
        </div>
      </div>
    </div>

    <div class="text-center">
      <button
        type="submit"
        class="gradient-button mt-5"
        (click)="onSubmit()"
        [disabled]="paymentForm.invalid"
      >
        {{ "Submit" | translate }}
      </button>
    </div>
  </form>
</div>
